import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

export const useSendEmailVerificationMutation = (options?: UseMutationOptions<true, AxiosError>) =>
  useMutation<true, AxiosError>(() => api.post('v2/send-verification-email').then((res) => res.data.data), options);
